/**
 * defa.views.InvitationCollectionView
 * A view presenting a collection of invitations.
 * @version 1.0.0
 */
import CollectionView from 'scripts/poppet/collection-view';
import InvitationView from 'scripts/defa/invitations/view-invitation-view';
import EmptyView      from 'scripts/defa/basic/view-empty-view';

const InvitationCollectionView = CollectionView.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	childView : InvitationView,
	emptyView : EmptyView,
	emptyViewOptions: {
		context: 'no:invitations',
	},
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});

export default InvitationCollectionView;
